module.exports = __webpack_public_path__ + "img/img_0.760ef61e.jpg";